<template>
  <div class="ma-4">
    <v-sheet v-show="showSkeleton" class="pa-3">
      <v-skeleton-loader class="mx-auto" type="table" />
    </v-sheet>

    <div v-show="!showSkeleton" class="text-h4 mb-2">Ramais</div>
    <v-data-iterator
      v-show="!showSkeleton"
      :no-data-text="noDataText"
      :items="dataRamais"
      :items-per-page.sync="itemsPerPage"
      :page="page"
      :search="search"
      :no-results-text="noResultsText"
      hide-default-footer
    >
      <template v-slot:header>
        <v-row align="center" class="ml-n6">
          <v-btn
            dark
            color="orangePcm"
            href="/pabx/cadastro/ramais/criar"
            target="_blank"
            class="ml-6"
            @click="handleGoToNewRamal"
          >
            Criar Ramal
          </v-btn>
          <v-btn
            dark
            color="orangePcm"
            href="/pabx/cadastro/ramais/criar-multiplos"
            target="_blank"
            class="ml-2"
            @click="handleGoToNewRamaisMultiplos"
          >
            Criar Múltiplos
          </v-btn>
          <download-excel
            worksheet="Ramais"
            :data="dataRamais"
            :fields="fieldsExcel"
            :meta="json_meta"
            name="ramaisPABX.xls"
          >
            <v-btn dark color="orangePcm" class="ml-2">
              Exportar
            </v-btn>
          </download-excel>
          <v-spacer />
          <v-col cols="4" class="mr-4">
            <v-text-field v-model="search" clearable hide-details prepend-inner-icon="mdi-magnify" label="Busca" />
          </v-col>
        </v-row>
      </template>

      <template v-slot:default="props">
        <v-data-table
          dense
          :headers="headers"
          :items="props.items"
          hide-default-footer
          class="elevation-1"
          disable-pagination
          @dblclick:row="atualizar"
        >
          <template v-slot:[`item.botoes`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  dark
                  color="bluePcm"
                  class="ma-2"
                  :href="`/pabx/cadastro/ramais/atualizar/${item._id}`"
                  target="_blank"
                  v-bind="attrs"
                  v-on="on"
                  @click="atualizarButton(item, $event)"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="deletar(item)" icon small dark color="darkRed" v-bind="attrs" v-on="on">
                  <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn>
              </template>
              <span>Remover</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </template>

      <template v-slot:footer>
        <v-row class="mt-2" align="center" justify="center">
          <div class="ml-4 mb-2 grey--text">
            <p>Ramais: PJSIP-PADRÃO: {{ qtdPjsip }} / PJSIP-WEBRTC: {{qtdPjsipWebrtc}} / Virtuais: {{ qtdVirtual }} / Total: {{ qtdPjsip + qtdVirtual }}</p>
          </div>
          <v-spacer />
          <div class="pb-5">
            <ListPagination
              :page="page"
              :numberOfPages="numberOfPages"
              @firstPage="firstPage"
              @formerPage="formerPage"
              @nextPage="nextPage"
              @lastPage="lastPage"
            />
          </div>
        </v-row>
      </template>
    </v-data-iterator>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import ListPagination from '@/componentes/ListPagination'
import { registerVuexModule } from '@/utils/vuexUtils'
import { pagesHomeMixins } from '@/mixins/pagesHomeMixins'

import ramaisStore from '../_store'
import RamaisHttpService from '../_services/RamaisHttpService'

export default {
  components: { ListPagination },

  mixins: [pagesHomeMixins],

  data: () => ({
    headers: [
      {
        text: 'Ramal',
        value: 'numero',
        align: 'left',
      },
      {
        text: 'Nome',
        value: 'usuario',
        align: 'left',
      },
      {
        text: 'Tipo',
        value: 'tipo',
        align: 'left',
        sortable: false,
      },
      {
        text: 'Ações',
        value: 'botoes',
        align: 'center',
        sortable: false,
      },
    ],
    dataRamais: [],
    fieldsExcel: {
      Ramal: 'numero',
      Usuário: 'usuario',
      Senha: 'senhaRamal',
      'Grupo de Captura': 'grupoCaptura',
    },
    json_meta: [
      {
        key: 'charset',
        value: 'utf-8',
      },
    ],
  }),
  computed: {
    ...mapGetters('ramaisHomeModulePABXStore', ['getRamais', 'getGrupos']),

    numberOfPages() {
      return Math.ceil(this.dataRamais.length / this.itemsPerPage)
    },
    qtdPjsip() {
      return this.dataRamais.filter(ramal => ramal.tipo && ramal.tipo === 'PJSIP-PADRÃO').length || 0
    },
    qtdVirtual() {
      return this.dataRamais.filter(ramal => ramal.tipo && ramal.tipo === 'VIRTUAL').length || 0
    },
    qtdPjsipWebrtc() {
      return this.dataRamais.filter(ramal => ramal.webrtc && ramal.webrtc == true).length || 0
    },
  },

  async created() {
    registerVuexModule(this.$store, 'ramaisHomeModulePABXStore', ramaisStore)
    await Promise.all([this.listarRamais(), this.listarGrupo()])
    this.dataRamais = [...this.getRamais.ramais]

    this.dataRamais.forEach(ramal => {

      const descriptionGrupoCaptura = this.getGrupos.find(grupoCaptura => grupoCaptura._id === ramal.grupoCaptura)
      if (descriptionGrupoCaptura) {
        ramal.grupoCaptura = descriptionGrupoCaptura.description
      }

      if(ramal.webrtc && ramal.webrtc == true){
        ramal.tipo = "PJSIP-WEBRTC"
      }

      if(ramal.tipo && ramal.tipo == 'PJSIP'){
        ramal.tipo = "PJSIP-PADRÃO"
      }

    })

    this.showSkeleton = false
  },

  methods: {
    ...mapActions('ramaisHomeModulePABXStore', ['listarRamais', 'listarGrupo']),

    handleGoToNewRamal(event) {
      event.preventDefault()
      if (event.metaKey || event.ctrlKey) {
        const goToNewRamal = this.$router.resolve({ name: 'ramais/criar' })
        window.open(goToNewRamal.href, '_blank')
      } else {
        this.$router.push({ name: 'ramais/criar' })
      }
    },

    handleGoToNewRamaisMultiplos(event) {
      event.preventDefault()
      if (event.metaKey || event.ctrlKey) {
        const goToNewRamaisMultiplos = this.$router.resolve({ name: 'ramais/criar-multiplos' })
        window.open(goToNewRamaisMultiplos.href, '_blank')
      } else {
        this.$router.push({ name: 'ramais/criar-multiplos' })
      }
    },

    atualizar(event, item) {
      if (event.metaKey || event.ctrlKey) {
        const updatePath = this.$router.resolve(`ramais/atualizar/${item.item._id}`)
        window.open(updatePath.href, '_blank')
      } else {
        this.$router.push(`ramais/atualizar/${item.item._id}`)
      }
    },

    atualizarButton(item, event) {
      event.preventDefault()
      if (event.metaKey || event.ctrlKey) {
        const updatePath = this.$router.resolve(`ramais/atualizar/${item._id}`)
        window.open(updatePath.href, '_blank')
      } else {
        this.$router.push(`ramais/atualizar/${item._id}`)
      }
    },

    async deletar(item) {
      let resultado = window.confirm(`Deseja remover o ramal "${item.numero}"?`)
      if (resultado) {
        try {
          await RamaisHttpService.deleteRamal(item._id)
          this.dataRamais = this.dataRamais.filter(x => x._id !== item._id)
        } catch (error) {
          alert(error.response.data)
        }
      }
    },
  },
}
</script>
